export const geoAPIOptions = {
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': 'c96dc4c240msh48bf748caaa8fdbp15a0f8jsn6849865f8768',
        'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
    }
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "419499d000bc118848c9d7273ebb3a0a"; 